import { useNavigate } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'
import { StatusBadge } from './StatusBadge'
import { PriorityBadge } from './PriorityBadge'
import { CategoryIcon } from './CategoryIcon'
import type { TicketListItem } from '../services/api'

function formatDate(iso: string): string {
  const d = new Date(iso)
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

interface TicketCardProps {
  ticket: TicketListItem
  projectSlug: string
  compact?: boolean
}

export function TicketCard({ ticket, projectSlug, compact }: TicketCardProps) {
  const navigate = useNavigate()

  return (
    <div
      onClick={() => navigate(`/${projectSlug}/tickets/${ticket.id}`)}
      className="bg-white border border-gray-200 rounded-lg p-4 hover:border-brand-300 hover:shadow-sm transition-all cursor-pointer"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-xs text-gray-400 font-mono">{ticket.ticket_number}</span>
            <StatusBadge status={ticket.status} />
          </div>
          <h3 className="text-sm font-medium text-gray-900 truncate">{ticket.subject}</h3>
          {!compact && (
            <div className="flex items-center gap-3 mt-2">
              <CategoryIcon category={ticket.category} showLabel />
              <PriorityBadge priority={ticket.priority} />
              <span className="text-xs text-gray-400">{formatDate(ticket.created_at)}</span>
              {ticket.due_date && (
                <span className="text-xs font-medium text-amber-600">
                  Due {formatDate(ticket.due_date)}
                </span>
              )}
            </div>
          )}
        </div>
        {ticket.response_count > 0 && (
          <span className="inline-flex items-center gap-1 text-xs text-gray-400">
            <MessageSquare className="w-3.5 h-3.5" />
            {ticket.response_count}
          </span>
        )}
      </div>
    </div>
  )
}
